import React, { useState, useEffect } from 'react';
import api from '../../../services/api';
import { Container, ContainerInterno, ContainerInternoCheck } from '../styles';
import RModal from '../../../components/Rsuite/Modal';
import { CustomButton } from '../../../components/CustomButton';
import { CustomInput } from '../../../components/CustomInput';
import { CustomToggle } from '../../../components/CustomToggle';
import { useCustomTheme } from '../../../hooks/useCustomTheme';
import { CustomSelectPicker } from '../../../components/CustomSelectPicker';
import { toastSuccess, toastInfo, toastWarning } from '../../../toasts';

const EditarCadastrarConta = ({
  modal,
  close,
  objConta,
  contas,
  setContas,
  IdEmpresa,
}) => {
  const [idConta, setIdConta] = useState('');
  const [banco, setBanco] = useState('');
  const [usaPix, setUsaPix] = useState(false);
  const [pix, setPix] = useState('');
  const [agencia, setAgencia] = useState('');
  const [conta, setConta] = useState('');
  const [favorecido, setFavorecido] = useState('');
  const [ativo, setAtivo] = useState(false);
  const [desabilitar, setDesabilitar] = useState(false);
  const { theme } = useCustomTheme();

  const dataAtivo = [
    { value: 1, label: 'Sim' },
    { value: 0, label: 'Não' },
  ].map((item) => ({ label: item.label, value: item.value }));

  const carregarDados = (conta) => {
    setIdConta(conta.Id);
    setBanco(conta.Banco);
    setUsaPix(Boolean(parseInt(conta.UsaPix)));
    setPix(conta.Pix);
    setAgencia(conta.Agencia);
    setConta(conta.Conta);
    setFavorecido(conta.Favorecido);
    setAtivo(conta.Ativo);
  };

  const salvar = () => {
    if (idConta !== '') {
      editar();
    } else {
      cadastrar();
    }
  };

  const cadastrar = async () => {
    setDesabilitar(true);
    if (validarCampos()) {
      await api
        .post('conta/criar', {
          IdEmpresa: IdEmpresa,
          UsaPix: usaPix,
          Pix: pix,
          Banco: banco,
          Agencia: agencia,
          Conta: conta,
          Favorecido: favorecido,
        })
        .then((res) => {
          setContas([...contas, res.data]);
          toastSuccess('Conta cadastrada');
          close();
        });
    } else {
      toastWarning('Preencha todos os campos');
    }
    setDesabilitar(false);
  };

  const editar = async () => {
    setDesabilitar(true);
    if (validarCampos()) {
      await api
        .patch(`conta/alterar/${idConta}`, {
          Banco: banco,
          UsaPix: usaPix,
          Pix: pix,
          Agencia: agencia,
          Conta: conta,
          Favorecido: favorecido,
          Ativo: ativo,
        })
        .then((res) => {
          toastInfo('Conta alterada');
          setContas((state) =>
            state.map((e) => {
              if (e.Id !== res.data.Id) {
                return e;
              }
              e = res.data;
              return e;
            }),
          );
          close();
        });
    } else {
      toastWarning('Preencha todos os campos');
    }
    setDesabilitar(false);
  };

  const validarCampos = () => {
    if (
      (banco !== '' && agencia !== '' && conta !== '') ||
      (pix !== '' && favorecido !== '')
    ) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (objConta) {
      carregarDados(objConta);
    }
  }, [objConta]);

  return (
    <RModal
      open={modal}
      onClose={close}
      title={objConta ? `Editar conta` : `Cadastro de conta`}
      footer={
        <>
          <CustomButton onClick={salvar} appearance="primary">
            Salvar
          </CustomButton>
          <CustomButton onClick={close} appearance="ghost">
            Fechar
          </CustomButton>
        </>
      }
    >
      <form
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gridTemplateRows: 'auto',
        }}
      >
        <Container>
          <ContainerInterno>
            <label htmlFor="banco">
              <b style={{ color: theme.colors.textSecondary }}>Banco</b>
            </label>
            <CustomInput type="text" value={banco} onChange={setBanco} />
          </ContainerInterno>
        </Container>

        <Container>
          <ContainerInternoCheck
            style={{
              justifyContent: 'space-between',
              paddingLeft: '10px',
              marginTop: '10px',
              width: '100%',
            }}
          >
            <label
              class="form-check-label"
              for="usaPix"
              style={{ marginRight: '10px', color: theme.colors.textSecondary }}
            >
              Chave Pix?
            </label>
            <CustomToggle
              id="usaPix"
              checked={usaPix}
              onChange={() => setUsaPix(!usaPix)}
            />
          </ContainerInternoCheck>
        </Container>
        {usaPix && (
          <Container style={{ gridColumn: 'span 2' }}>
            <ContainerInterno style={{ width: '100%' }}>
              <label htmlFor="agencia">
                <b style={{ color: theme.colors.textSecondary }}>Chave Pix</b>
              </label>
              <CustomInput type="text" value={pix} onChange={setPix} />
            </ContainerInterno>
          </Container>
        )}
        {!usaPix && (
          <>
            <Container>
              <ContainerInterno>
                <label htmlFor="agencia">
                  <b style={{ color: theme.colors.textSecondary }}>Agência</b>
                </label>
                <CustomInput
                  type="text"
                  value={agencia}
                  onChange={setAgencia}
                />
              </ContainerInterno>
            </Container>
            <Container>
              <ContainerInterno>
                <label htmlFor="conta">
                  <b style={{ color: theme.colors.textSecondary }}>Conta</b>
                </label>
                <CustomInput type="text" value={conta} onChange={setConta} />
              </ContainerInterno>
            </Container>
          </>
        )}
        <Container>
          <ContainerInterno>
            <label htmlFor="favorecido">
              <b style={{ color: theme.colors.textSecondary }}>Favorecido</b>
            </label>
            <CustomInput
              type="text"
              value={favorecido}
              onChange={setFavorecido}
            />
          </ContainerInterno>
        </Container>

        <Container>
          {idConta !== '' && (
            <ContainerInterno>
              <b style={{ color: theme.colors.textSecondary }}>Ativo</b>
              <CustomSelectPicker
                data={dataAtivo}
                style={{ width: 200 }}
                onChange={setAtivo}
                defaultValue={+ativo}
                searchable={false}
              />
            </ContainerInterno>
          )}
        </Container>
      </form>
    </RModal>
  );
};

export default EditarCadastrarConta;
